
import Icon from '@/components/UntitledUI/Icon.vue'
import Tippy from '@/components/common/Tippy.vue'

export default {
    name: 'AccountManager',
    components: {
        Icon,
        Tippy
    },
    data () {
        return {
            accountManager: null,
            loading: true,
            showNewLabel: false
        }
    },
    computed: {
        firstName () {
            return this.accountManager.name
                ? this.accountManager.name.trim().split(' ')[0]
                : ''
        },
        phoneNumber () {
            if (this.$helpers.isLtr()) {
                return '+' + this.accountManager.phone
            }
            return this.accountManager.phone + '+'
        }
    },
    beforeMount () {
        this.showNewLabel = !localStorage.getItem('accountManagerNewLabel')
    },
    methods: {
        getAccountManager () {
            this.$axios.get('v1/account-manager')
                .then(({ data }) => {
                    this.accountManager = data.data
                })
                .catch(() => {
                    this.$toast.error(this.$t('general error'))
                    this.accountManager = null
                })
                .finally(() => {
                    this.loading = false
                })
        },
        handleClick () {
            if (this.showNewLabel) {
                localStorage.setItem('accountManagerNewLabel', 'true')
                this.showNewLabel = false
            }
            this.getAccountManager()
        }
    }
}
